
    import __i18nConfig from '@next-translate-root/i18n'
    import __appWithI18n from 'next-translate/appWithI18n'
    import { apolloOptions, APP_NAME, authOptions } from '@apps/config';
import Layout from '@apps/layouts';
import type { EmotionCache } from '@emotion/cache';
import { CacheProvider } from '@emotion/react';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { Logo } from '@stack/components/components';
import { accentColor } from '@stack/theme';
import { createEmotionCache, LayoutConfigProvider } from '@webbyx/mui';
import { useAuthIdentity, withApolloClient, withAuthIdentity, withRouteIndicator, } from '@webbyx/next-js';
import compose from 'lodash/flowRight';
import { NextPage } from 'next';
import { AppProps } from 'next/app';
import Head from 'next/head';
import { useThemeConfig } from '../config/theme.config';
import 'animate.css';
import '@stack/theme/styles/globals.scss';
import 'react-perfect-scrollbar/dist/css/styles.css';
type ExtendedAppProps = AppProps & {
    Component: NextPage;
    emotionCache: EmotionCache;
};
const clientSideCache = createEmotionCache();
const MyApp = (props: ExtendedAppProps) => {
    const { Component, emotionCache = clientSideCache, pageProps } = props;
    // =============== HOOKS
    const { authUser } = useAuthIdentity();
    const config = useThemeConfig();
    // =============== HELPERS
    const router = props.router;
    const setPageThemeSettings = Component.setPageThemeSettings ?? undefined;
    const getLayout = (page: React.ReactElement) => {
        if (authOptions.paths?.noLayoutPaths?.includes(router.pathname)) {
            return page;
        }
        return <Layout>{page}</Layout>;
    };
    // =============== VIEWS
    return (<CacheProvider value={emotionCache}>
      <Head>
        <meta name="viewport" content="width=device-width, initial-scale=1 maximum-scale=1"/>
        <title>{APP_NAME}</title>
      </Head>
      <LayoutConfigProvider authUser={authUser} config={config} paths={[router.asPath, router.pathname]} pageSettings={setPageThemeSettings?.()} loader={{ brand: <Logo alt="Logo" width={250}/> }}>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          {getLayout(<Component {...pageProps}/>)}
        </LocalizationProvider>
      </LayoutConfigProvider>
    </CacheProvider>);
};
const __Next_Translate__Page__18e4d1b68c7__ = compose(withApolloClient({ ssr: true, options: apolloOptions }), withAuthIdentity({ ssr: true, apollo: true, options: authOptions }), withRouteIndicator({ color: accentColor }))(MyApp);

    export default __appWithI18n(__Next_Translate__Page__18e4d1b68c7__, {
      ...__i18nConfig,
      isLoader: true,
      skipInitialProps: false,
      
    });
  